import React from 'react';
import { Button, Badge } from 'antd';
import { network, asserts } from '../../../utils';
import api from '../../../config/api';
import eventBus from '../Container/EventBus';
import Context from '../Container/Context';
import { useDidMount } from '../../use';
import { isEmpty } from 'ramda';
import './CornerCart.less';

export default () => {
  const { principal, history, permCart } = React.useContext(Context);
  const isLoginIn = asserts.isExist(principal);

  const [cartCount, setCartCount] = React.useState(0);

  const fetchCartCount = async () => {
    const response = await network.get(api.core.cartCount);
    if (response.success) {
      setCartCount(response.data.data || 0);
    }
  };

  React.useEffect(() => {
    const unlisten = history.listen(() => isLoginIn && fetchCartCount());
    return () => unlisten();
  });

  useDidMount(() => {
    fetchCartCount();
    eventBus.addListener(eventBus.type.UPDATE_CART_COUNT, () => fetchCartCount());
  });

  const handleCartClick = () => {
    history.push(permCart.menuUrl);
  };

  if (!isLoginIn) return null;
  if (isEmpty(permCart)) return null;

  return (
    <Button className="header-cart" icon="shopping-cart" onClick={handleCartClick}>
      <Badge count={cartCount} offset={[10, 0]} showZero overflowCount={999}>
        {permCart.moduName}
      </Badge>
    </Button>
  );
};
